import axios from 'axios'
import conf from './conf'
import {
  rejects
} from 'assert';

var VUE = null
const HOST = ''; //conf.HOSTS.IT4
const TOKEN = /(\?|&)(accessToken|token)=([^&]+)/.test(location.search) ? decodeURIComponent(RegExp.$3).replace(/ /g, '+') : '';
// const TOKEN = 'MhrrVJkjM/jxGCgH6KTpLv9xoD+9ky++kMWk+U1PHZTdfjl8qXNxIT0mljiYASC82Hc3EAv/2NSFAIRvNGJjXvZD539XYlLuH2oFyDBrrzwXpdRVBv/0q6AQ18Hc3rTwxMU9WttV/PBrVTUTkMBxkoW2sGy3ezx7';
const TOKEN_ENCODE = encodeURIComponent(TOKEN);

const httpAxios = axios.create({
  baseURL: `${HOST}/api/mall/v1/business`,
  timeout: conf.TIMEOUT,
  headers: {
    token: TOKEN,
    'x-dm-user-token': TOKEN
  }
});

const submitAxios = axios.create({
  baseURL: `${HOST}/api/local/v1/business`,
  timeout: 300000,
  headers: {
    token: TOKEN,
    'x-dm-user-token': TOKEN
  }
});

const httpAxiosLocal = axios.create({
  baseURL: `${HOST}/api/local/v1`,
  timeout: conf.TIMEOUT,
  headers: {
    token: TOKEN,
    'x-dm-user-token': TOKEN
  }
});

const raffleAxios = axios.create({
  baseURL: `${HOST}/api/local/v1/raffle`,
  timeout: conf.TIMEOUT,
  headers: {
    token: TOKEN,
    'x-dm-user-token': TOKEN
  }
});

/**/
const API = {
  async getBusinessAnalysis(businessId) {
    var timeZoneStr = encodeURIComponent(VUE.prototype.$utils.getTimeZoneStr())
    return httpAxios.get(`/verify/get-analysis?businessId=${businessId}&timezone=${timeZoneStr}&accessToken=${TOKEN_ENCODE}`);
  },
  async feedback() {
    var result = await httpAxiosLocal.get('/business/feedback/get-pageMsg/list');
    if (result && result.status === 200 && result.data && result.data.success && result.data.data) {
      return result.data.data;
    } else {
      return false;
    }
  },
  async submitFeedback(data) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          try {
            var result = JSON.parse(xhr.responseText);
            if (result && result.success) {
              resolve(result);
            } else {
              reject(result ? result.error : '');
            }
          } catch (error) {
            reject(error);
          }
        } else {
          reject('xhr faild');
        }
      };
      xhr.onerror = function () {
        reject('xhr error');
      }
      xhr.open('post', '/api/local/v1/business/feedback/submit', true);
      xhr.setRequestHeader('x-dm-user-token', TOKEN);
      xhr.send(data);
    });
    // var result = await submitAxios.post('feedback/submit', data);
    // if (result && result.status === 200 && result.data && result.data.success) {
    // 	return true;
    // } else {
    // 	throw Error('submit failed');
    // }
  },
  sendResetEmail(params) {
    return httpAxiosLocal.post('/business/send-reset-email', params)
  },
  // 获取抽奖记录
  async getBonusRecords (businessId) {
    return await raffleAxios.get(`/biz/monitor/history-record?businessId=${businessId}`);
  },
  // 获取抽奖活动数据: 必须传活动ID
  async getBonusData (raffleId = '') {
    return await raffleAxios.get(`/biz/monitor/data-analysis?raffleId=${raffleId}`);
  },
  // 设置奖品数据: 必须传活动ID
  async setBonusData (params) {
    return await raffleAxios.post(`/biz/monitor/set-raffle-goods`, params);
  },
  async getStoreActivityState (businessId) {
    return await raffleAxios.get(`/biz/get-activity-qr?businessId=${businessId}`);
  },
  async getCustomerFlowData(params) {
    return await httpAxiosLocal.get(`/assistant/biz-customer-data?token=${TOKEN}&time=${params.time}&type=${params.type}`);
  },


}

export default (Vue) => {
  VUE = Vue
  VUE.prototype.$utils.extend(VUE.prototype.$api, API)
}



// WEBPACK FOOTER //
// ./src/api/app.js